import { useEffect, useCallback } from 'react';
import { useSocket as useSocketContext } from '../contexts/SocketContext';

export const useSocket = () => {
    const socketContext = useSocketContext();

    const emit = useCallback((event: string, data?: any) => {
        socketContext.emit(event, data);
    }, [socketContext]);

    const emitWithAck = useCallback((event: string, data?: any, callback?: (response: any) => void) => {
        socketContext.emitWithAck(event, data, callback);
    }, [socketContext]);

    const emitWithPromise = useCallback((event: string, data?: any, timeout?: number) => {
        return socketContext.emitWithPromise(event, data, timeout);
    }, [socketContext]);

    const on = useCallback((event: string, callback: (...args: any[]) => void) => {
        socketContext.on(event, callback);
    }, [socketContext]);

    const off = useCallback((event: string, callback?: (...args: any[]) => void) => {
        socketContext.off(event, callback);
    }, [socketContext]);

    return {
        ...socketContext,
        emit,
        emitWithAck,
        emitWithPromise,
        on,
        off,
    };
};

export default useSocket; 